import { render, staticRenderFns } from "./simCardResource.vue?vue&type=template&id=1a713db1&scoped=true&"
import script from "./simCardResource.vue?vue&type=script&lang=js&"
export * from "./simCardResource.vue?vue&type=script&lang=js&"
import style0 from "./simCardResource.vue?vue&type=style&index=0&id=1a713db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a713db1",
  null
  
)

export default component.exports